import Dropdown from 'react-bootstrap/Dropdown';
import { DropField } from '../../../elements/general';
import { useEffect, useRef, useState } from 'react';
import useRequestLocation from '../../../../hooks/useRequestLocation';
import { useTranslation } from 'react-i18next';
import { CategoryPickerComponent } from '@me-pos/category-picker';
import { BsChevronUp } from 'react-icons/bs';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { getFormattedPeriod } from './utils';
import {
  setCategoryLevel,
  setIsArchivedSelectedCategoryl
} from '../../../../redux/slices/mePosData';

const HaircutSelectFilter = ({
  endData,
  startData,
  selectedMaster,
  setHairstyles,
  setService,
  selectedHairstyle
}) => {
  const isArchivedSelectedCategory = useSelector(
    (state) => state.mePosData.isArchivedSelectedCategory
  );
  const [hairstylesList, setHairstylesList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const { getHairstyles } = useRequestLocation();
  const dropdownRef = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const { periodToStart, periodToEnd } = getFormattedPeriod(startData, endData);

    getHairstyles(periodToEnd, periodToStart, selectedMaster).then(
      (countHairstyles) => {
        const categoriesWithSubcategories = countHairstyles.reduce((acc, item) => {
          const isParentCategory = item.parentCategoryId.buckets.length > 0;

          if (isParentCategory) {
            const parentId = item.parentCategoryId.buckets[0].key;
            const parentName = item.parentCategoryName.buckets[0]?.key || '';
            const parentDeleted = !!item.parentCategoryDeleted.buckets[0]?.key;

            // Checking if such a parent category already exists
            let existingParent = acc.find(cat => cat.id === parentId);

            if (!existingParent) {
              existingParent = {
                id: parentId,
                name: `${parentName}${parentDeleted ? ` ${t('filters.archive')}` : ''}`,
                nameOriginal: parentName,
                isDeleted: parentDeleted,
                subcategoryList: [],
              };
              acc.push(existingParent);
            }

            // adding subcategories
            item.subcategories.buckets.forEach(el => {
              existingParent.subcategoryList.push({
                id: el.subcategoryId.buckets[0].key,
                name: `${el.key}${!!el.subcategoryDeleted.buckets[0].key ? ` ${t('filters.archive')}` : ''}`,
                nameOriginal: el.key,
                isDeleted: !!el.subcategoryDeleted.buckets[0].key,
              });
            });

          } else {
            // category without parent
            acc.push({
              id: item.key,
              name: `${item.category.buckets[0].key}${
                !!item.categoryDeleted.buckets[0].key ? ` ${t('filters.archive')}` : ''
              }`,
              nameOriginal: item.category.buckets[0].key,
              isDeleted: !!item.categoryDeleted.buckets[0].key,
              subcategoryList: [],
            });
          }

          return acc;
        }, []);
        setHairstylesList(categoriesWithSubcategories);
      }
    );
    // eslint-disable-next-line
  }, [startData, endData, selectedMaster]);

  const handleChangeCategory = (e) => {
    dispatch(setIsArchivedSelectedCategoryl(e.isPicked ? e.isDeleted : false));
    dispatch(setCategoryLevel(e.isPicked ? 'parent' : ''));
    setHairstyles(e.isPicked ? e.nameOriginal : 'all');
    setIsOpen(false);
  };

  const handleChangeSubcategory = (e) => {
    dispatch(setIsArchivedSelectedCategoryl(e.isPicked ? e.isDeleted : false));
    dispatch(setCategoryLevel(e.isPicked ? 'sub' : ''));
    setHairstyles(e.isPicked ? e.nameOriginal : 'all');
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        className="position-relative rounded-1"
        style={{ marginBottom: isOpen ? 50 : undefined }}
      >
        <div
          className="position-absolute"
          style={{ top: 14, right: 10, zIndex: isOpen ? 2 : -1 }}
          onClick={() => setIsOpen(false)}
        >
          <BsChevronUp />
        </div>
        <div
          className={`position-absolute bg-white w-100 rounded-1 ${
            isOpen ? 'border' : 'border-0'
          }`}
          style={{ zIndex: 1 }}
          ref={dropdownRef}
        >
          <CategoryPicker>
            <CategoryPickerComponent
              serviceCategories={hairstylesList}
              onSearchChange={(e) => {}}
              onChangeCategory={handleChangeCategory}
              onChangeSubcategory={handleChangeSubcategory}
              locale={i18n.language}
              isOpen={isOpen}
            />
          </CategoryPicker>
        </div>
      </div>
      {!isOpen && (
        <DropField
          className="custom-dropdown py-2 rounder-4px border overflow-hidden"
          onClick={() => setIsOpen(true)}
        >
          <Dropdown.Toggle className="form-select overflow-hidden">
            <span className="col-11 text-start text-truncate pe-2">
              {selectedHairstyle === 'all'
                ? t('filters.allCategories')
                : `${selectedHairstyle}${
                    isArchivedSelectedCategory ? ' ' + t('filters.archive') : ''
                  }`}
            </span>
          </Dropdown.Toggle>
        </DropField>
      )}
    </>
  );
};

export default HaircutSelectFilter;

const CategoryPicker = styled.div`
    input {
        padding-top: 12px;
        padding-bottom: 12px;
        border-radius: 4px;
        border: none;
        border-bottom: 1px solid #DEDEDE;
    }

    input::placeholder {
        font-family: "Arial", sans-serif;
        font-size: 14px;
    }

    input:focus {
        border-bottom: transparent;
        box-shadow: 0 0 0 .25rem rgb(88, 66, 190, 0.25);
        color: #1F3354;
  }
`;